import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=cf1b9896&scoped=true"
import script from "./ControlBar.vue?vue&type=script&lang=js"
export * from "./ControlBar.vue?vue&type=script&lang=js"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=cf1b9896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1b9896",
  null
  
)

export default component.exports